export function ErrorMessage({ message = 'Something went wrong.' }) {
  return (
    <div className="empty-state" role="alert">
      <p className="text-muted">{message}</p>
    </div>
  );
}
